{
  "build_id": "70e2d5e3fa",
  "build_timestamp": 1788263779000,
  "environment": "prod",
  "version": "release-bw-tf-4.1.2"
}
